import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { CIPStatisticPayload } from '../../NewStatistics.types';

const QUERY_KEY = 'GET_CIP_STATISTIC_QUERY';

const useGetCIPStatisticQuery = () => {
  const {
    observingOrganization: { type, id },
  } = useCurrentOrganization();

  const isSystemLevel = useMemo(() => type === OrganizationTypes.system, [type]);

  const { isLoading, data, isSuccess } = useQuery(
    [QUERY_KEY, type, id],
    () => api.get(API_URL.METRICS_CIP_INFO),
    {
      enabled: !isSystemLevel,
    }
  );

  const formattedData = useMemo<CIPStatisticPayload | null>(() => {
    const responseData = data?.data;

    if (responseData) {
      return {
        passed: responseData?.passed || 0,
        pending: responseData?.pending || 0,
        failed: responseData?.failed || 0,
      };
    }

    return null;
  }, [data?.data]);

  const isEmpty = useMemo(() => {
    if ((isSuccess && !formattedData) || isSystemLevel) {
      return true;
    }
    return false;
  }, [formattedData, isSuccess, isSystemLevel]);
  return {
    isLoading,
    isEmpty,
    isSuccess,
    data: formattedData,
  };
};
export default useGetCIPStatisticQuery;
